import tw, { styled } from 'twin.macro';
import { useTranslation } from 'next-i18next';

import { getAssetSrc } from '@restworld/utils-common';
import { Button, JobPositionCard, JobPositionCardProps } from '@restworld/ui-ds';

import { useLoginSignupPopup } from '../../../../hooks';

const cards: JobPositionCardProps[] = Array.from({ length: 3 }, () => ({
  showRestaurantDetails: true,
  restaurantName: 'Lavazza',
  city: 'Milano',
  jobTitle: 'Cameriere alle colazioni per hotel di lusso',
  occupation: 'Cameriere',
  salaryMin: 1500,
  salaryMax: 1300,
  jobType: 'Full Time',
  publishedAt: new Date('2020-08-27T08:24:37.642Z'),
  redirectUrl: null,
  restaurantLogo: getAssetSrc('/utils-assets/lavazza-logo.svg'),
}));

export const HomePageSignup = () => {
  const { t } = useTranslation('home-page');
  const { onStartSignup } = useLoginSignupPopup();
  // const { trackEvent } = useAnalytics();
  return (
    <Container>
      <Title>{t('to_discover')} 🔥</Title>
      <Header>{t('right_job')}</Header>
      <Description>{t('offer_you_best_jobs')}</Description>
      <div tw="flex lg:flex-col flex-col-reverse items-center w-full gap-8 mt-8">
        <Button
          icon="LockOpenIcon"
          onClick={() => {
            onStartSignup();
            // trackEvent('initiate_create_account', {
            //   origin: 'sidebar',
            // });
          }}
        >
          <span tw="text-base leading-6 font-semibold text-primary-900 ">{t('unlock_access')}</span>
        </Button>
        <CardContainer>
          {cards.map((card: JobPositionCardProps, index) => (
            <JobPositionCard {...card} key={index} />
          ))}
        </CardContainer>
      </div>
    </Container>
  );
};

const Container = styled.div(() => [tw`flex flex-col items-center w-full box-border lg:pt-0 pt-16`]);

const Title = styled.h5(() => [tw`lg:text-lg text-base uppercase lg:leading-6.75 leading-6 font-medium text-center`]);

const Header = styled.h3(() => [
  tw`text-black lg:text-4xl text-3xl  lg:leading-13.5 leading-9  font-semibold text-center mt-1`,
]);

const Description = styled.p(() => [
  tw`lg:text-lg text-base  lg:leading-6.75 leading-6  text-center text-black lg:mt-2 mt-4`,
]);

const CardContainer = styled.div(() => [
  tw`relative grid lg:grid-cols-3 grid-cols-1 w-full filter blur-0.75 lg:gap-6 gap-4 pointer-events-none`,
]);
